<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listAccountPlans"
        :title-table="$t('Account Plan')"
        module="accountPlanSettingsModule"
        sort-name="classe"
        :show-btn-add="verificarPermissao('ROLE_FINAN_INSERIR')"
        :show-action-delete="verificarPermissao('ROLE_FINAN_DELETAR')"
        @add="addNew"
        @edit="edit"
      />
      <FormAccountPlan v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import { verificarPermissao } from '@/auth/utils'
import FormAccountPlan from './forms/FormAccountPlan.vue'

export default {
  name: 'AccountPlan',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormAccountPlan
  },
  computed: {
    ...mapState('accountPlanSettingsModule', {
      listAccountPlans: (state) => state.listAccountPlans
    })
  },
  data() {
    return {
      verificarPermissao,
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id'
        },
        {
          label: 'Classe',
          field: 'classe'
        },
        {
          label: 'Natureza',
          field: 'codNatureza'
        },
        {
          label: this.$t('Action'),
          field: 'action'
        }
      ],
      pageConfig: {
        page: 1,
        size: 10,
        sort: 'classe',
        order: 'asc'
      }
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'accountPlanSettingsModule/prepareToEditAccountPlan',
        data
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    }
  }
}
</script>
